import React, { createContext, useContext, useReducer } from 'react'
import axios from 'axios'
import { useState } from 'react'

import { Link } from "gatsby"
import Layout from '../components/layout'

import "./login.css"

const apiURL = process.env.API_URL

const Register = ({ redirect }) => {
    const [email, setEmail] = useState('')
    const [username, setUsername] = useState('')
    const [name, setName] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')

    const handleRegister = async (event) => {
        event.preventDefault()

        const registerInfo = {
            email: email,
            username: username,
            name: name,
            password: password
        }

        const textReg = /^[a-zA-Z\d\-_\s]+$/i

        const emailReg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if (!emailReg.test(registerInfo.email)) {
            setError("Please enter a valid email address.")
            return
        }

        if (!textReg.test(registerInfo.username)) {
            setError("Please enter a valid username.")
            return
        }

        if (!textReg.test(registerInfo.name)) {
            setError("Please enter a valid name.")
            return
        }

        if (!textReg.test(registerInfo.name)) {
            setError("Please enter a valid password.")
            return
        }

        try{
            axios.post(`${apiURL}/auth/local/register`, registerInfo)
            setError("Welcome to OneGrow, " + registerInfo.name + "! Navigate backto the login page and login!")
        
        }catch(e){
            console.log("Error occurred during register.")
            console.log(e)
            const { response: { data: { message: [{ messages: [error]}] } } } = e
            const { message: msg} = error
            setError(msg)
        }

    }

    return (
        <div id="lay">
            <Layout>
                <div id="logbox1">
                    <div id="topbox">
                        <h1 className="tit">Sign Up</h1>

                        <Link to="/app" id="homelink">
                            <div id="homelinkbox">Back to Login</div>
                        </Link>
                    </div>
                    <br/>
                    <form id="regform"
                        onSubmit={handleRegister}
                        >
                        <div>
                            <input
                                className="inbox" 
                                placeholder="Email"
                                onChange={ e => {
                                    setEmail(e.target.value)
                                }}
                                value={ email }
                                
                            />
                        </div> <br/>
                        <div>
                            <input 
                                className="inbox" 
                                placeholder="Username"
                                onChange={ e => {
                                    setUsername(e.target.value)
                                }}
                                value={ username }
                                
                            />
                        </div> <br/>
                        <div>
                            <input 
                                className="inbox" 
                                placeholder="Name"
                                onChange={ e => {
                                    setName(e.target.value)
                                }}
                                value={ name }
                                
                            />
                        </div> <br/>
                        <div>
                            <input type="password"
                                className="inbox" 
                                placeholder="Password"
                                onChange={ e => {
                                    setPassword(e.target.value)
                                }}
                                value={ password }
                                
                            />
                        </div> <br/>
                        <div>
                            <button id="subbut" type="submit">
                                <div id="subbox">Register</div>
                            </button>
                        </div>
                    </form> 
                    { (error.length > 1) && (
                        <p>{ error }</p>
                    )}
                </div>
            </Layout>
        </div>  
    )
}

export default Register